import Carousel from '../../modules/carousel/carousel';
import DeviceWidth from '../../utils/device';

const propertyList = document.getElementsByClassName('p-propertyList')[0];
const swiperElements = propertyList.getElementsByClassName('swiper-container') as HTMLCollectionOf<HTMLElement>;
const deviceWidth: DeviceWidth = DeviceWidth;
const options = {
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};
const carouselArray = [];
// Make instances for each apartment
for (let i = 0; i < swiperElements.length; i++) {
  carouselArray.push(new Carousel(swiperElements[i], options, 'mobile'));
}

// Run init on resize
let timeoutId: any;
window.addEventListener('resize', () => {
  clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    carouselArray.forEach(carousel => {
      carousel.init();
    });
  }, 200);
});

// Make instances for appended list on mobile
const targetParent = document.getElementById('js-monitor-append');
if (deviceWidth.mobile && targetParent) {
  // appedされたタイミングを監視
  const appendObserver = new MutationObserver(mutations => {
    mutations.forEach(() => {
      carouselArray.forEach(carousel => {
        carousel.stop();
      });
      for (let i = 0; i < swiperElements.length; i++) {
        carouselArray.push(new Carousel(swiperElements[i], options, 'mobile'));
      }
    });
  });
  const observerConfig = { attributes: true, childList: true, characterData: true };
  appendObserver.observe(targetParent, observerConfig);
}
